<template>
  <div v-if="hasAuth">
    <slot></slot>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    code: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters([
      'appCode'
    ]),
    hasAuth() {
      return this.appCode.includes(this.code)
    }
  }

}
</script>
